if (!customElements.get('megamenu-element')) {
  class MegamenuElement extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        items: '[data-image]',
        image: '[megamenu-image-element]',
        spinner: '.megamenu---loader'
      };
      this.init();
    }

    init() {
      const items = this.querySelectorAll(this.selectors.items);
      const imageElement = this.querySelector(this.selectors.image);
      const spinner = this.querySelector(this.selectors.spinner);

      if (!items.length || !imageElement) return;

      items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          const newImageUrl = item.getAttribute('data-image');
          if (!newImageUrl) return;

          // Show spinner while loading
          if (spinner) spinner.classList.remove('hidden');

          // Preload image first
          const tempImage = new Image();
          tempImage.src = newImageUrl;

          tempImage.onload = () => {
            imageElement.src = newImageUrl;
            if (spinner) spinner.classList.add('hidden');
          };

          // Hide spinner if the image fails to load
          tempImage.onerror = () => {
            if (spinner) spinner.classList.add('hidden');
            console.warn(`Image failed to load: ${newImageUrl}`);
          };
        });
      });
    }
  }

  customElements.define('megamenu-element', MegamenuElement);
}